"use client"

import { useSearchParams, useRouter } from 'next/navigation';
import GalleryTab from './GalleryTab/GalleryTab';
import { PublicationsTab } from './PublicationsTab/PublicationsTab';
import { useTranslations } from 'next-intl';
import { FinishedEvent } from '@/app/interfaces/event';
import { ShowcaseImage } from '@/app/interfaces/showcaseImage';
import Tabs, { TabItem } from '@/components/ui/Tabs/Tabs';
import { Publication } from '@/app/interfaces/publication';


export function MediaTabs({ 
  events, 
  highlights,
  youtubeVideos,
  magazines 
}: { 
  events: FinishedEvent[], 
  highlights: ShowcaseImage[],
  youtubeVideos: Publication[],
  magazines: Publication[]
}){
    const t = useTranslations('MediaPage');

const mediaTabsData: TabItem[] = [
        {
            id: 'gallery',
            label: t("eventsGallery"),
            content: <GalleryTab events={events} highlights={highlights}/> 
        },
        {
            id: 'publications',
            label: t("publications"),
            content: <PublicationsTab youtubeVideos={youtubeVideos} magazines={magazines} />
        }
    ];

    return (
        <Tabs
            tabs={mediaTabsData}
            defaultTab="gallery"
            ariaLabel="Media navigation"
        />
    )
}